<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：会员-升级审核-基础设置
  -->
  <div class="pb50" v-loading="loading">
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <div class="common-form">基础设置</div>
      <el-form-item label="是否开启审核升级：">
        <el-radio-group v-model="form.open_review">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="选择审核升级等级： ">
        <el-select v-model="form.review_grade" multiple placeholder="请选择" style="width: 250px">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name"  :value="item.grade_id">
          </el-option>
        </el-select>
          <div class="gray9">开启后，只有选中的会员等级才能进行审核升级</div>
      </el-form-item>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
  </div>
</template>
<script>
  import ReviewApi from '@/api/review.js';
  export default {
    components: {

    },
    data() {
      return {
        form: {
         /*是否开启*/
         open_review: 0,
         //选择审核升级等级
         review_grade: [],
        },
         gradeList: [],
        /*是否正在加载*/
        loading: true,
      };
    },
    created() {
      /*获取列表*/
      this.getSetting();
    },
    methods: {
      /*获取设置*/
      getSetting() {
        let self = this;
        let Params = {};
        ReviewApi.getSetting(Params, true)
          .then(data => {
            self.form = data.data.detail;
            self.gradeList = data.data.gradeList;
            self.loading = false;
          })
          .catch(error => {});
      },
      /*点击保存*/
      onSubmit() {
        let self = this;
        let params = self.form;
        self.loading = true;
        ReviewApi.saveSetting(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，保存成功',
                type: 'success'
              });
              self.getSetting();
            } else {
              self.loading = false;
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/user/review/setting/Setting.vue